import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const advantages = ['Most countertop installations are completed in one day!', 'We warranty our work for one year from the installation date.', 'Digital templating without removing existing countertops.', 'Design your own perfect kitchen or bathroom with our visualizer tools!', 'We do all of the work from start to finish - no subcontractors.', 'Over 200 years of combined experience in the industry'];
export function AdvantageSection() {
  return <section className="w-full bg-brand-cream" data-id="element-20" data-mp="13fayuwgdo81h">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-21" data-mp="187uahnvi8t3n">
        <div className="max-w-3xl" data-id="element-22" data-mp="1d6xinh6s7ffu">
          <h2 className="font-display text-3xl text-brand-charcoal sm:text-4xl" data-id="element-23" data-mp="1d5vtk8sxksf4">
            The Granite &amp; Marble Works Advantage
          </h2>
          <p className="mt-5 text-base leading-relaxed text-gray-600" data-id="element-24" data-mp="1m7vbr4fom2jn">
            We have the largest selection of stone in stock between NYC and Montreal.
          </p>
          <p className="mt-4 text-base leading-relaxed text-gray-600" data-id="element-25" data-mp="37cf3es7km4fc">
            Founded in 2003, we are a family-owned business with a focus on skilled
            craftsmanship, first-quality materials, and superior customer service.
          </p>
          <p className="mt-4 text-base leading-relaxed text-gray-600" data-id="element-26" data-mp="2tbujfspx62k9">
            Our passion for elevating homes comes from over 40 years of experience in
            construction, home remodeling, and stonework.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-27" data-mp="3m0i8lzdshc33">
          {advantages.map((item, index) => <motion.div key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-start gap-3" data-id="element-28" data-mp="3h6xdcf3kyw7l" data-mpi={index}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-teal" data-id="element-29" data-mp="1tbr2mjbg69bm">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-30" data-mp="1y9slb34yo6mk" />
              </span>
              <p className="text-base text-brand-charcoal" data-id="element-31" data-mp="1jd1u3h5fy181">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}